<template>
  <div class="time-item">
    <div class="time-hms">{{ time }}</div>
    <div class="time-ymd">{{ day }}</div>
  </div>
</template>

<script>
export default {
  name: "LocalTime",
  data() {
    return {
      time: "",
      day: "",
      interval: null,
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.interval = setInterval(() => {
      this.initData();
    }, 1000);
  },
  methods: {
    initData() {
      const a = new Date();
      this.day = a.toLocaleDateString();
      this.time = this.getCurrentTime();
    },
    getCurrentTime() {
      const now = new Date();
      let hours = now.getHours();
      let minutes = now.getMinutes();
      let seconds = now.getSeconds();

      // 确保时间格式为 HH:mm:ss
      hours = hours < 10 ? "0" + hours : hours;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      seconds = seconds < 10 ? "0" + seconds : seconds;

      return hours + ":" + minutes + ":" + seconds;
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped lang="less">
.time-item {
  height: 100%;
  color: #c2c6cb;
  .time-hms {
    font-size: 2rem;
  }
  .time-ymd {
    font-size: 1rem;
    text-align: right;
  }
}
</style>